import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { ProfileService } from '../services/profile.service';
import { FirmwareDetails } from '../types/firmware-details';
import { FirmwareSet } from '../types/firmware-set';

@Component({
  selector: 'firmware-edit',
  template: `<div style="display: block">
  <div class="editrow">
    <mat-form-field>
      <input #name placeholder="A name for this firmware"
             matInput [(ngModel)]="firmware.name" (ngModelChange)="changed()" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <input #author placeholder="The author of this firmware"
             matInput [(ngModel)]="firmware.author" (ngModelChange)="changed()">
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
    <textarea #comment placeholder="A comment or description of this firmware" rows="2"
              matInput [(ngModel)]="firmware.comment" (ngModelChange)="changed()"></textarea>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field id="fwsetid">
      <mat-select placeholder="Change default firmware set" [(ngModel)]="firmware.fwsetid" (ngModelChange)="changed()">
        <mat-option *ngFor="let firmwareSet of inFirmwareSets" [value]="firmwareSet.fwsetid">
          {{firmwareSet.fwsetid}} - {{firmwareSet.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox #stable labelPosition="after"
                  [(ngModel)]="firmware.stable" (ngModelChange)="changed()">stable</mat-checkbox>
    <mat-checkbox #breakingchange labelPosition="after"
                  [(ngModel)]="firmware.breakingchange" (ngModelChange)="changed()">breaking change</mat-checkbox>
    <div class="panel">
      <button mat-raised-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="!hasChanges">Save</button>
    </div>
  </div>
</div>
<div id="error" class="error" *ngIf="!!errorMessage">{{errorMessage}}</div>
`,
  styleUrls: ['./firmware-edit.component.css'],
  providers: [ HubService ],
})

export class FirmwareEditComponent implements OnInit {
  @Input() inFirmware: FirmwareDetails;
  @Input() inFirmwareSets: FirmwareSet[];
  @Output() firmware_saved = new EventEmitter<boolean>();
  @Output() minimised = new EventEmitter<boolean>();
  firmware: FirmwareDetails;
  hasChanges = false;
  errorMessage: string;

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    if (!ProfileService.HasRight('firmwares')) {
      this.errorMessage = 'You must have the "firmwares" right to edit firmware.';
      return;
    }
    if (!this.inFirmware) { this.inFirmware = new FirmwareDetails(); }
    this.firmware = Object.assign({}, this.inFirmware);  // Clone
  }

  changed() {
    this.hasChanges = true;
  }

  cancel(): void {
    this.minimised.emit(false);
  }

  save(): void {
    this.hubService.updateFirmware(this.firmware)
      .subscribe(
        () => {
          this.inFirmware = this.firmware;
          this.firmware_saved.emit(true);
          this.hasChanges = false;
          this.minimised.emit(true);
        },
        e => this.errorMessage = e
      );
  }
}
